import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";

const API_URL = "https://zpanel.zentragroup.cl/app/api";

export default function ClientSignIn() {
  const [rutDisplay, setRutDisplay] = useState("");
  const [rutRaw, setRutRaw] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const navigate = useNavigate();

  const formatRut = (value) => {
    if (!value) return "";

    const clean = value.replace(/[^0-9kK]/g, "").toUpperCase();
    const dv = clean.slice(-1);
    let body = clean.slice(0, -1);

    let formatted = "";

    while (body.length > 3) {
      formatted = "." + body.slice(-3) + formatted;
      body = body.slice(0, -3);
    }

    formatted = body + formatted;

    return body ? `${formatted}-${dv}` : dv;
  };

  const handleRutChange = (e) => {
    const clean = e.target.value.replace(/[^0-9kK]/g, "").toUpperCase();

    setRutRaw(clean);
    setRutDisplay(formatRut(clean));
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!rutRaw) {
      setError("Ingresa el RUT del titular.");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const response = await fetch(`${API_URL}/login_cliente.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          rut: rutDisplay,
        }),
      });

      const text = await response.text();

      if (!text) {
        throw new Error("PHP respondió vacío");
      }

      const data = JSON.parse(text);

      if (!data.success) {
        setError(data.message || "No se pudo iniciar sesión.");
        return;
      }

      localStorage.setItem("cliente", JSON.stringify(data.cliente));
      localStorage.setItem("portal_token", data.token || "");
      navigate("/MiPerfil");
    } catch (err) {
      console.error("Error real:", err);
      setError("No se pudo conectar con el servidor.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-white text-slate-900 relative">
      <div className="absolute inset-0 bg-brand-radials -z-10" />

      <Navbar />

      <main className="mx-auto max-w-6xl px-4 pt-20 pb-16 flex justify-center">
        <div className="w-full max-w-lg">
          <div className="relative overflow-hidden rounded-3xl bg-white/90 backdrop-blur-md ring-1 ring-slate-200 shadow-[0_24px_80px_rgba(15,23,42,0.18)]">
            <div className="h-1.5 w-full bg-gradient-to-r from-[var(--brand-1)] via-[var(--brand-3)] to-[var(--brand-4)]" />

            <div className="px-6 py-7 sm:px-8 sm:py-9">
              <div className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white/70 px-3 py-1 text-[11px] font-medium text-slate-600">
                Panel clientes
                <span className="inline-block h-1.5 w-1.5 rounded-full bg-[var(--brand-3)]" />
              </div>

              <h1 className="mt-4 text-3xl font-semibold tracking-tight text-slate-900">
                Acceso clientes
              </h1>

              <p className="mt-1 text-sm text-slate-600">
                Ingresa el RUT del titular para acceder a tu panel Zentra.
              </p>

              <form onSubmit={handleSubmit} className="mt-6 space-y-5">
                <div>
                  <label
                    htmlFor="rut"
                    className="block text-sm font-medium text-slate-800 mb-1.5"
                  >
                    RUT del titular
                  </label>

                  <div
                    className="
                      rounded-2xl border border-slate-200 bg-slate-50/80
                      focus-within:border-[var(--brand-1)]
                      focus-within:ring-1 focus-within:ring-[var(--brand-1)]
                      px-3.5 py-2.5 transition
                    "
                  >
                    <input
                      id="rut"
                      name="rut"
                      autoComplete="off"
                      inputMode="text"
                      placeholder="12.345.678-9"
                      className="w-full bg-transparent outline-none text-base text-slate-900 placeholder:text-slate-400"
                      value={rutDisplay}
                      onChange={handleRutChange}
                    />
                  </div>

                  <p className="mt-1 text-xs text-slate-500">
                    Escribe el RUT del titular. Puede incluir K.
                  </p>

                  {error && (
                    <p className="mt-3 rounded-xl bg-red-50 px-3 py-2 text-sm text-red-600 border border-red-100">
                      {error}
                    </p>
                  )}
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className="
                    mt-2 w-full rounded-2xl py-3 text-sm font-semibold text-white
                    bg-gradient-to-r from-[var(--brand-1)] via-[var(--brand-3)] to-[var(--brand-4)]
                    shadow-[0_16px_45px_rgba(15,23,42,0.4)]
                    hover:brightness-110 active:translate-y-[1px]
                    transition-all duration-150
                    disabled:opacity-60 disabled:cursor-not-allowed
                  "
                >
                  {loading ? "Ingresando..." : "Ingresar"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}